module.exports = __webpack_public_path__ + "img/desk-panic.5eff5919.svg";